import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermModal.css';

export interface TermsModalProps {
    onAccept: () => void;
    nav?: (p: string) => void | Promise<void>;
}

export const TermsModal: React.FC<TermsModalProps> = ({ onAccept, nav }) => {
    const navigate = useNavigate();

    return (
        <div className="terms-modal-overlay">
            <div className="terms-modal-window glass-ui">
                Пожалуйста, ознакомьтесь с нашей <button type="button" style={{ textDecoration: 'underline', cursor: 'pointer', background: 'none', border: 'none', padding: 0, font: 'inherit', color: 'inherit' }} onClick={() => navigate('/term_of_use')}>
                    страницей условий использования
                </button>
                <p>
                    Продолжая использовать сервис, вы соглашаетесь с этими условиями.
                </p>
                <button onClick={onAccept}>ОК</button>
            </div>
        </div>
    );
};